import { render, staticRenderFns } from "./TVR.vue?vue&type=template&id=03b68c8a&scoped=true"
import script from "./TVR.vue?vue&type=script&lang=js"
export * from "./TVR.vue?vue&type=script&lang=js"
import style0 from "./TVR.vue?vue&type=style&index=0&id=03b68c8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b68c8a",
  null
  
)

export default component.exports